<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Dashboard</h1>

<div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4">

  @for (item of dashboard; track item) {
    <div class="tw-bg-white tw-border tw-border-gray-200 tw-rounded-md">
      @switch (item) {
        @case ('slaAlarms') {
          <app-widget-sla-alarms></app-widget-sla-alarms>
        }
        @case ('nonSlaAlarms') {
          <app-widget-non-sla-alarms></app-widget-non-sla-alarms>
        }
        @case ('globalAlarms') {
          <app-widget-global-alarms></app-widget-global-alarms>
        }
        @case ('stats') {
          <app-widget-stats></app-widget-stats>
        }
      }
    </div>
  }
</div>
